import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getUserGeography = api(async function getUserGeography() {
    return query(
        gql`
            query getUserGeography {
                getUserGeography
            }
        `,
        {},
        { returns: "getUserGeography" }
    )
})
